export default __webpack_public_path__ + "static/MaisonNeue-DemiBold-b73e62bd7108fd24947378cd9030c9e9.woff2";